import React from 'react'
import { Container } from './MapControl.styles'
import { MapControlProps } from './MapControl.types'

export const MapControl: React.FC<MapControlProps> = ({
  icon,
  title,
  active = false,
  onClick,
  disabled = false,
  size = 'medium',
  className,
  style,
  'aria-label': ariaLabel,
  iconStyle,
}) => {
  return (
    <Container
      className={className}
      style={style}
      $active={active}
      $size={size}
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel || title}
      type="button"
    >
      <span className="icon" style={iconStyle}>
        {icon as any}
      </span>
    </Container>
  )
}
